import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function SitePreview() {
  const { siteId } = useParams();
  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/sites/${siteId}/html`, { credentials: 'include' })
      .then(res => res.text())
      .then(data => {
        setHtml(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [siteId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0F172A] flex items-center justify-center">
        <Loader2 className="animate-spin text-orange-500" size={32} />
      </div>
    );
  }

  return (
    <div data-testid="site-preview-page" className="min-h-screen">
      <iframe
        srcDoc={html}
        title="Site Preview"
        className="w-full min-h-screen border-0"
        sandbox="allow-same-origin"
        data-testid="site-preview-iframe"
      />
    </div>
  );
}
